import { Button } from '@/components/shadcn/button'
import { IconV2LockOutline } from '@icons/IconV2LockOutline'
import { ReviewUsersForm } from '../../Forms/ReviewUsersForm'
import { ArchiveWorkspaceConfirmDialog } from './ArchiveWorkspaceConfirmDialog'

type OrganisationWorkspaceRowActionsProps = {
  workspaceId: number
  hasUsers: boolean
}

export function OrganisationWorkspaceRowActions({ workspaceId, hasUsers }: OrganisationWorkspaceRowActionsProps) {
  return (
    <div className="flex items-center justify-end gap-x-1">
      {hasUsers && (
        <ReviewUsersForm
          sheetTrigger={
            <Button size="icon" variant="ghost" aria-label="Review user access">
              <IconV2LockOutline className="size-5" />
            </Button>
          }
          sheetTriggerTooltip="Review user access"
          workspaceId={workspaceId}
        />
      )}
      <ArchiveWorkspaceConfirmDialog workspaceId={workspaceId} />
    </div>
  )
}
